import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CmsLinkCollectionComponent } from '../../../core/model';

export enum LinkCollectionComponentTypes {
  SocialLinkComponent = 'SocialLinkComponent',
  AlphabeticalLinkComponent = 'AlphabeticalLinkComponent',
}

@Component({
  selector: 'py-link-collection',
  templateUrl: './link-collection.component.html',
  styleUrls: ['./link-collection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LinkCollectionComponent implements OnInit {
  linkCollectionComponentType$: Observable<LinkCollectionComponentTypes>;
  constructor(public cmsComponent: CmsComponentData<CmsLinkCollectionComponent>) {}

  ngOnInit(): void {
    this.linkCollectionComponentType$ = this.cmsComponent.data$.pipe(
      take(1),
      map((data) =>
        data?.styleClasses?.includes && data.styleClasses.includes('link-collection-alphabetical')
          ? LinkCollectionComponentTypes.AlphabeticalLinkComponent
          : LinkCollectionComponentTypes.SocialLinkComponent
      )
    );
  }
}
